module.exports = __webpack_public_path__ + "img/TED_red-scene.01dc81d2.svg";